/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Italian
export default {
  'fabric.atlassianSwitcher.switchTo': 'Passa a',
  'fabric.atlassianSwitcher.switchToTooltip': 'Passa a...',
  'fabric.atlassianSwitcher.recent': 'Recenti',
  'fabric.atlassianSwitcher.more': 'Altri',
  'fabric.atlassianSwitcher.try': 'Prova',
  'fabric.atlassianSwitcher.manageList': 'Gestisci elenco',
  'fabric.atlassianSwitcher.jiraProject': 'Progetto Jira',
  'fabric.atlassianSwitcher.confluenceSpace': 'Spazio Confluence',
  'fabric.atlassianSwitcher.people': 'Persone',
  'fabric.atlassianSwitcher.administration': 'Amministrazione',
  'fabric.atlassianSwitcher.discoverMore': 'Scopri altri prodotti',
  'fabric.atlassianSwitcher.errorHeading': 'Si è verificato un problema',
  'fabric.atlassianSwitcher.errorText': "Teniamo traccia di questi errori, ma puoi contattarci se l'aggiornamento non risolve il problema",
  'fabric.atlassianSwitcher.errorImageAltText': 'Problema con il robot e diverse persone sono impegnate nella sua risoluzione.',
  'fabric.atlassianSwitcher.expand': 'Espandi'
};